export const coursePathFromPagePath = (pagePath) => {
  if (
    pagePath.indexOf(`courses/`) === -1 ||
    pagePath.indexOf(`courses/`) > pagePath.length - 'courses/'.length - 1
  ) {
    return null;
  }
  return `${pagePath.split('courses/')[0]}courses/${
    pagePath.split('courses/')[1].split('/')[0]
  }`;
};

export const courseCodeFromPath = (path) => {
  const coursesSplit = `/${path}`.split('/courses/');
  if (coursesSplit.length < 2) {
    return null;
  }
  return coursesSplit[1].split('/')[0] || null;
};

export const courseSubPathFromPath = (path) => {
  const segments = path.split('/');
  if (segments.length < 3) {
    return null;
  }
  if (segments[0] === 'courses') {
    return segments.slice(2).join('/');
  }
  if (segments[1] !== 'courses') {
    return null;
  }
  if (segments.length < 4) {
    return null;
  }
  return segments.slice(3).join('/');
};

export const cohortCodeFromPath = (path) => {
  let rawpath = path;
  // remove leading slash
  if (path.startsWith('/')) {
    rawpath = path.slice(1);
  }
  const courseSubPath = courseSubPathFromPath(rawpath);
  if (!courseSubPath || !courseSubPath.startsWith('cohorts')) {
    return null;
  }
  const segments = courseSubPath.split('/');
  if (segments.length < 2) {
    return null;
  }
  return segments[1];
};

export const institutionPrefixFromPath = (path) => {
  const coursesSplit = `/${path}`.split('/courses/');
  if (coursesSplit.length < 2) {
    return null;
  }
  return coursesSplit[0].split('/')[1] || null;
};

export const cohortSubPathFromCourseSubPath = (courseSubPath) => {
  const segments = courseSubPath.split('/');
  if (segments[0] === 'cohorts' && segments.length >= 2) {
    return segments.slice(2).join('/');
  }
  return null;
};

export const isGroupPageFromPath = (path) => {
  const courseSubPath = courseSubPathFromPath(path);
  if (!courseSubPath) {
    return false;
  }
  const cohortSubPath = cohortSubPathFromCourseSubPath(courseSubPath);
  if (!cohortSubPath) {
    return false;
  }
  const segments = cohortSubPath.split('/');
  return segments.length === 1 && segments[0] === 'groups';
};

export const isCohortPagesFromSubpath = (subpath) => {
  return subpath.startsWith('cohorts/') && subpath.length > `cohorts/`.length;
};

export const pagePathFromCourseInfo = (
  institutionPrefix,
  courseCode,
  subPath
) => {
  return institutionPrefix
    ? `${institutionPrefix}/courses/${courseCode}/${subPath}`
    : `courses/${courseCode}/${subPath}`;
};
